import { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { PriceTablePopup } from "./priceTablePopup";
import { GlobalContext } from "../../../Context/GlobalContext";
import { QuantityStripper } from "../../../Layout/Common/quantityStripper";
import { WishListContainer } from "./wishListContainer";
import { ExportFileContainer } from "./exportFileContainer";
import { ToolbarContainer } from "../toolbarContainer";
import { useAuth } from "../../../Context/AuthContext";

export const OtherActivity = ({ params, isBuyable }) => {
  const [familyData, setFamilyData] = useState(null);
  const [prodDetail, setProdDetail] = useState(null);
  const [cartItem, setCartItem] = useState(null);
  const [isShowAddCard, setIsShowAddCard] = useState(true);
  const globalcontext = useContext(GlobalContext);
  const { userId, eBayBlock, isBrowseOnly } = useAuth();

  useEffect(() => {
    setIsShowAddCard(isBuyable && !isBrowseOnly ? true : false);
  }, [isBuyable, isBrowseOnly]);

  useEffect(() => {
    if (
      globalcontext.CartItem &&
      globalcontext.CartItem.cartItem &&
      globalcontext.CartItem.cartItem.length > 0 &&
      params
    ) {
      var products = globalcontext.CartItem.cartItem;
      var filterProductId = products.find((item) => String(item.prod_id) == String(params.productId));
      setCartItem({
        prod_id: params.productId,
        qty: filterProductId && filterProductId.qty ? filterProductId.qty : 0,
      });
    } else {
      setCartItem({
        prod_id: params.productId,
        qty: 0,
      });
    }
  }, [globalcontext.CartItem, params]);

  useEffect(() => {
    setFamilyData(params);
    setProdDetail({
      productId: params.productId,
      productCode: params.sku,
      familyId: params.familyId,
      productDescription: params.productDescription,
      productImage: params.productImage,
    });
  }, [params]);

  return (
    <Fragment>
      {familyData && (
        <div className="pro-qty-list">
          {eBayBlock && familyData.iseBayBlock ? (
            <div>
              <p className="text-danger">This product is not available for purchase.</p>
            </div>
          ) : (
            isShowAddCard && (
              <div className="rowProduct-qty product-detail-qty" style={{ display: "block" }}>
                <QuantityStripper
                  prd={cartItem}
                  params={{
                    code: prodDetail?.productCode,
                    prodId: prodDetail?.productId,
                    desc: prodDetail?.productDescription,
                    img: prodDetail?.productImage,
                  }}
                />
              </div>
            )
          )}
          <div className="product-adding-icons">
            <ToolbarContainer product={prodDetail} cartItem={cartItem} showPrint={true} />
          </div>
          {/* Adding Icons */}
        </div>
      )}
    </Fragment>
  );
};
